import { IonButtons, IonMenuButton } from '@ionic/react';
import React from 'react';
import './MenuButton.css';

const MenuButton: React.FC = () => {
    return (
        <IonButtons slot="start">
            <IonMenuButton />
        </IonButtons>
    );
}

export default MenuButton;